var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h16v16H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.665.351c.386.387.417.982.07 1.329L7.4 6l4.334 4.32c.322.322.319.858.007 1.243l-.077.086c-.386.386-.98.42-1.328.073L6 7.397l-4.337 4.324c-.323.322-.858.317-1.242.005l-.086-.077c-.386-.387-.417-.982-.07-1.329L4.598 6 .265 1.68C-.057 1.358-.054.822.258.437L.335.351c.386-.386.98-.42 1.328-.073L6 4.601 10.337.278c.323-.321.858-.316 1.242-.004z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.a4fdc9d35a770864a7e6200b000b558e.svg";
export { ForwardRef as ReactComponent };